import React, {useState} from 'react'
import * as Yup from 'yup'
import {Link, useNavigate} from 'react-router-dom'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import {getForgotPasswordData, fetchAsyncForgotPassword} from '../../../Redux/FrontEnd'
import './Frontend_Auth_Components/Registration.scss'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

export function ForgotPassword() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const dispatch = useDispatch()
  const status = useSelector(getForgotPasswordData)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      const data = {email: values.email}
      dispatch(fetchAsyncForgotPassword(data)).then(
        (res: any) => res?.payload?.status && navigate('/auth')
      )
    },
  })
  return (
    <>
      <form
        className='form w-100  fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='card-body'>
          <div className='text-center mb-10'>
            {/* begin::Title */}
            <h1 className='text-dark mb-3'>Forgot Password ?</h1>
            {/* end::Title */}

            {/* begin::Link */}
            <div className='text-gray-400 fs-5'>Enter your email to reset your password.</div>
            {/* end::Link */}
          </div>

          {/* begin::Title */}
          {hasErrors === true && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>
                Sorry, looks like there are some errors detected, please try again.
              </div>
            </div>
          )}

          {hasErrors === false && (
            <div className='mb-10 bg-light-info p-8 rounded'>
              <div className='text-info'>Sent password reset. Please check your email</div>
            </div>
          )}
          {/* end::Title */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
            <input
              type='email'
              placeholder='Email'
              autoComplete='off'
              {...formik.getFieldProps('email')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {'is-invalid': formik.touched.email && formik.errors.email},
                {
                  'is-valid': formik.touched.email && !formik.errors.email,
                }
              )}
            />
            {formik.touched.email && formik.errors.email && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert' className='text-danger'>
                    {formik.errors.email}
                  </span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <Link to='/auth/login'>
              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn cancleBtn fw-bolder me-4'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                Cancel
              </button>
            </Link>{' '}
            <button
              type='submit'
              id='kt_password_reset_submit'
              className='btn btn-lg  fw-bolder auth-primary-btn'
            >
              <span className='indicator-label text-white'>Submit</span>
              {loading && (
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
          {/* end::Form group */}
        </div>
        <div className='auth-bottom-pages'>
          <ul>
            <li>
              <a target='_blank' href='https://www.cellcast.com/au/legal/terms-of-use'>
                Terms
              </a>
            </li>
            <li>
              <a target='_blank' href='https://www.cellcast.com/au/legal/privacy-policy'>
                Privacy
              </a>
            </li>
            <li>
              <a href={`mailto:info@cellcast.com`}>Contact us</a>
            </li>
          </ul>
        </div>
      </form>
    </>
  )
}
